import ZkDSTSaveOrUpdate from './src/main'
ZkDSTSaveOrUpdate.install = function (Vue) {
  Vue.component(ZkDSTSaveOrUpdate.name, ZkDSTSaveOrUpdate)
}
export default ZkDSTSaveOrUpdate



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/dstSaveOrUpdate/index.js